var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CBadge',{staticClass:"text-capitalize",attrs:{"color":this.color(),"shape":"pill"}},[_vm._v(_vm._s(this.text()))])
}
var staticRenderFns = []

export { render, staticRenderFns }